@if (gotPrerequisites()) {
    <div
        class="well"
        data-test-automation="tenure-summary">
        <h5>{{getFormerTenureUIConfigLookup().parentTenureGroupLabel}}</h5>
        @if (getApplicableFormerTenureSubjectOfPlanLookups().length &&  (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
            <div data-test-automation="tenure-summary-subject-options">
                @for (option of getApplicableFormerTenureSubjectOfPlanLookups(); track option) {
                    <label class="nlr-radio">
                        <input
                            type="radio"
                            name="formerTenureSubject"
                            #formerTenureSubject
                            [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                            [value]="option"
                            [(ngModel)]="getModel().formerTenureSubject"
                            [required]="true"
                            data-test-automation="tenure-summary-subject-option-{{option.id}}" />
                        <span>{{option.description}}</span>
                    </label>
                }
                <!-- TODO -->
                <!--        <div *ngIf="formerTenureSubject.invalid && tenureForm.$submitted" class="help-block">-->
                <!--            <span>Error!</span>-->
                <!--            <span>Required</span>-->
                <!--        </div>-->
            </div>
        }
        @if (showAffectedTenure()) {
            <nlr-affected-tenure
                [summaryViewModel]="summaryViewModel"
                [dataLabelMap]="getLabelMap()"
                [removeTenureDisabled]="removeTenureDisabled()"
                [removeLotDisabled]="removeLotDisabled()"
                (dataRemoveLot)="removeLot($event.tenureIndex, $event.lotIndex)"
                (dataRemoveTenure)="removeTenure($event.tenureIndex)">
            </nlr-affected-tenure>
        }
        @if (isFormerTenureDisplay('FORMER_TENURE')) {
            <nlr-former-tenure
                [pdfCreationMethod]="getPdfCreationMethod()"
                [summaryViewModel]="summaryViewModel"
                [dataLabelMap]="getLabelMap()"
                [removeTenureDisabled]="removeTenureDisabled()"
                [removeLotDisabled]="removeLotDisabled()"
                (dataRemoveLot)="removeLot($event.tenureIndex, $event.lotIndex)"
                (dataRemoveTenure)="removeTenure($event.tenureIndex)">
            </nlr-former-tenure>
        }
        <div class="row">
            <div class="col-xs-12">
                @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
                    <button
                        type="button"
                        id="maintainFormerTenure"
                        class="btn btn-default nlr-btn-sm"
                        (click)="edit(false)"
                        [disabled]="isEditDisabled() || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                        title="Add former tenure"
                        data-test-automation="tenure-summary-edit"
                        >{{getModel().formerTenures.length ? 'Edit' : 'Add'}}
                    </button>
                }
            </div>
        </div>
        @if (tenureCardinalityErrorMessage() && isValidated()) {
            <div class="row">
                <div class="col-xs-12">
                    <div class="help-block">
                        <span>Error!</span>
                        <span>{{tenureCardinalityErrorMessage()}}</span>
                    </div>
                </div>
            </div>
        }
    </div>
}
